import { amountUntilFreeShipping, FREE_SHIPPING_MIN_TOTAL, formatMoney } from '@c214/shared';

export function FreeShippingBar({ itemsTotal }: { itemsTotal: number }) {
  const remaining = amountUntilFreeShipping(itemsTotal);
  if (remaining <= 0) return null;

  const progress = (itemsTotal / FREE_SHIPPING_MIN_TOTAL) * 100;

  return (
    <div className="mb-4">
      <p className="text-[13px] text-ink">
        Додайте товарів ще на{' '}
        <span className="font-bold text-accent">{formatMoney(remaining)}</span>, щоб отримати
        безкоштовну доставку
      </p>
      {/* biome-ignore lint/a11y/useSemanticElements: custom-styled meter needs a div for the accent-colored fill; native <meter> can't be styled to match */}
      <div
        className="mt-2 h-1 w-full bg-line"
        role="meter"
        aria-label="Прогрес до безкоштовної доставки"
        aria-valuenow={Math.round(progress)}
        aria-valuemin={0}
        aria-valuemax={100}
      >
        <div
          className="h-full bg-accent"
          style={{ width: `${progress}%`, transition: 'width 300ms ease-out' }}
        />
      </div>
    </div>
  );
}
